module.exports = __webpack_public_path__ + "img/6.a1b3a36e.png";